module.exports = __webpack_public_path__ + "static/img/big-4.a535106.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-4.png
// module id = YqeL
// module chunks = 64